export default "__VITE_ASSET__CCvjQijP__"